export const SITE_TYPE = {
  CN: 1,
  INTL: 2
};

export const VIEW_STATUS = {
  ALL: 'all',
  PUBLISHED: 'published',
  REVIEWING: 'reviewing',
  OFFLINE: 'offline',
  DRAFT: 'draft'
};

export const PUBLISHED = {
  OFFLINE: 0,
  SUBMITTED: 1,
  DRAFT: 2
};

export const AUDIT_STATUS = {
  REVIEWING: 0,
  APPROVED: 1
};

export const IMAGE_TYPE = {
  ORIGINAL: 'original',
  PROCESSED: 'processed'
};

export const AI_OPERATION = {
  POLISH_TEXT: 'polishText',
  PROCESS_NEW_IMAGES: 'processNewImages',
  POLISH_AND_PROCESS: 'polishTextAndProcessNewImages'
};

export const SITE_OPTIONS = [
  { label: '中国站', value: SITE_TYPE.CN },
  { label: '国际站', value: SITE_TYPE.INTL }
];

export const VIEW_STATUS_OPTIONS = [
  { label: '全部', value: VIEW_STATUS.ALL },
  { label: '已上架', value: VIEW_STATUS.PUBLISHED },
  { label: '已下架', value: VIEW_STATUS.OFFLINE },
  { label: '草稿', value: VIEW_STATUS.DRAFT }
];

export const PRODUCT_IMAGE_UPLOAD_SOURCE = 23;
